import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {loadActions} from "../components/action/actionAction";
import Actions from "../components/action/Actions";
import {ROLE_ADMIN, ROLE_AMBASSADOR, ROLE_CODIR, ROLE_ENJOY} from "../permissions/roleTypes";
import FunctionalPage from "./FunctionalPage";

const ActionsPage = () => {

    const {actions} = useSelector(state => state.actions)
    const {id: userId, roles} = useSelector(state => state.currentUser)
    const {status: currentUserStatus, id:currentUserId} = useSelector(state => state.currentUser)

    const dispatch = useDispatch()

    const displayActionAccordingToRole = () => {
        let actionsSelected
        if (roles.includes(ROLE_ADMIN) ||
            roles.includes(ROLE_CODIR) ||
            roles.includes(ROLE_AMBASSADOR) ||
            roles.includes(ROLE_ENJOY)) {
            actionsSelected = actions
        } else {
            actionsSelected = actions.filter(a => a.pilot.id === userId)
        }
        return actionsSelected
    }
    useEffect(() => {
        // waiting that the current user is fetched to load actions(asynchronous to handle refresh token)
        if (currentUserStatus === 200) {
            dispatch(loadActions(currentUserId))
        }
    }, [currentUserId, currentUserStatus, dispatch])

    return (
        <FunctionalPage
            title={"actions"}
            component={
                <Actions
                    actions={displayActionAccordingToRole()}
                    inActionPage={true}
                />}
        />
    )
}


export default ActionsPage